import { connect } from "react-redux";
import React from "react";
import { bindActionCreators } from "redux";
import moment from "moment";
import HeaderComponent from "../header/header";
import LoadingOverlay from "react-loading-overlay";
import ModalHeader from "../header/subHeader";
import { RouteComponentProps, Link } from "react-router-dom";
import { IProject, IAuthenticationState, IApplicationState } from "../../../../models/applicationState";
import IProjectActions, * as projectActions from "../../../../redux/actions/projectActions";
const divStyle = {}
export interface IAnalysisProps extends RouteComponentProps, React.Props<Analysis> {
    project: IProject;
    path: object;
    loggedInUser: IAuthenticationState;
    actions: IProjectActions;
}

function mapStateToProps(state: IApplicationState) {
    return {
        project: state.currentProject,
        loggedInUser: state.loggedInUser,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(projectActions, dispatch),
    };
}

export interface IAnalysisState {
    analysisData: any;
    loadAnalysisData: boolean;
    fmetrics:any;
}

@connect(mapStateToProps, mapDispatchToProps)

export default class Analysis

    extends React.Component<IAnalysisProps, IAnalysisState> {
    public state: IAnalysisState = {
        analysisData: {},
        loadAnalysisData: false,
        fmetrics:[],
    };

    public async componentDidMount() {
        const projectName = this.props.match.params["projectName"];
       // debugger;
        if (projectName) {
            this.setState({ loadAnalysisData: true });
            const data = await this.props.actions.getAnalyseResult(projectName, "yes");
            if (data) {
                const dataObj = Object.assign({}, data);
               // const today = moment().format("YYYY/MM/DD");
              // const today = moment().format("DD-MMM-YYYY");
               const today = moment(dataObj.date).format("DD-MMM-YYYY");
              // moment(model.created_date, "YYYY-MM-DD HH:mm:ss").format("DD-MMM-YYYY")
                dataObj.currentDate = today;

                //

         const fmetrics = dataObj.fields_metrics?dataObj.fields_metrics.split('$$')[0]:{};
         const fields_metrics=[]; 
        const lbl1 = fmetrics?fmetrics.split("{"):[];
 
lbl1.forEach((lblval) =>{
                                        if (lblval.includes("fieldName")) {
                                           
                                           const lbl3 =lblval.split('fieldName');
                                         const lbl4 =lbl3[1].split(',');
                                          const lbl5 =lbl4[0].split(':');
                                          const lbl5a =lbl4[1].split(':');

                                          const lbl6 = lbl5[1].trim().replace("'","");
                                           const lbl6a = lbl5a[1].trim().replace("'","");
                                          const flName = lbl6.substr(0,lbl6.length-1);
                                         //   AllLabels.push(flName);
                                          
                                          const lbl7a = lbl6a.substr(0,lbl6a.length-1);
                                          const accur = lbl7a.split('}')[0];
                                          
                                            //AllLabels1.push(accur);
                                          
                                          
                                          fields_metrics.push(
                                            {'fieldName':flName,'accuracy':accur }
                                          );
                                          
                                        }  
                                        });
                                    

                //

                this.setState({ analysisData: dataObj, loadAnalysisData: false, fmetrics:fields_metrics });
            } else {
                this.setState({ analysisData: {}, loadAnalysisData: false });
            }
        }
    }



    public render() {
        const { analysisData,fmetrics } = this.state;       
        const { match } = this.props;
        return (
            <div style={divStyle} >
                <LoadingOverlay
                    active={this.state.loadAnalysisData}
                    spinner
                    className=""
                    text="loading Analysis Data"
                >
                    <HeaderComponent
                        history={this.props.history}
                        match={this.props.match}
                        location={this.props.location} />
                    <ModalHeader
                        history={this.props.history}
                        match={this.props.match}
                        actions={this.props.actions}
                        location={this.props.location}
                        project={this.props.project} />

                    <div className="container-fluid">
                        <div className="row mt-4">
                            <div className="offset-2 col-md-8 gutters-5-ipad">
                                <div className="card shadow">
                                    <div className="row">
                                        <div className="col-md-10">
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <label> Project Name :</label> {analysisData && analysisData.project_name}
                                                </div>

                                                <div className="col-md-6 text-right">
                                                    <label> Accuracy :</label> {analysisData.accuracy ? `${(analysisData.accuracy * 100).toFixed(2)} %` : "Not Trained"}
                                                </div>
                                                <div className="col-md-6">
                                                    <label> Model ID :</label> {analysisData && analysisData.model_id}
                                                </div>
                                                <div className="col-md-6 text-right">
                                                    <label> Date :</label> {analysisData && analysisData.currentDate}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="card shadow mt-2">

                                    <div className="wrap-body-test">
                                        {analysisData && analysisData.fields_metrics ?
                                            <>

                                                <table className="table table-dark table-striped">
                                                    <thead>
                                                        <tr>
                                                            <th>Name</th>
                                                            <th> Accuracy </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {fmetrics.map((fields, index) => {
                                                            const accuracy = (fields.accuracy * 100).toFixed(2);
                                                            return (
                                                                <tr key={index}>
                                                                    <td>{fields.fieldName}</td>
                                                                    <td>{accuracy} %</td>
                                                                </tr>
                                                            );
                                                        })}
                                                    </tbody>
                                                </table>
                                            </>
                                            : <span className="text-center mt-5">No Fields</span>}
                                    </div>                                    
                                    
                                    <div className="text-center mt-2">
                                        <Link
                                            to={`/OCRProjects/${match.params["projectName"]}/${match.params["projectId"]}/ocr/test-files/na`}
                                            className="btn btn-md"><i className="fa fa-check-circle" aria-hidden="true"> </i> Test</Link>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </LoadingOverlay>
            </div>
        );
    }
}
